import React from 'react';
import PropTypes from 'prop-types';
import onError from '../../../utils/onError';
import ErrorUi from '../ErrorUi/ErrorUi';

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    displayErrorMessaging: PropTypes.bool,
  };

  static defaultProps = {
    displayErrorMessaging: true,
  };

  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    onError(error, function (event) {
      event.addMetadata('react', errorInfo);
    });

    this.setState({ error, errorInfo });
  }

  render() {
    const { error, errorInfo } = this.state;
    const { children, displayErrorMessaging } = this.props;

    if (error || errorInfo) {
      if (displayErrorMessaging) {
        return <ErrorUi />;
      }

      return '';
    }

    return children;
  }
}

export default ErrorBoundary;
